import React from 'react';
import PropTypes from 'prop-types';
import { FaTimes } from 'react-icons/fa';
import './modal.scss';

const Modal = ({ children, primarySubmitLabel, secondarySubmitLabel, onPrimarySubmit, onSecondarySubmit, onExitClick, title }) => {
	const handlePrimarySubmit = () => {
		onPrimarySubmit();
	}

	const handleSecondarySubmit = () => {
		onSecondarySubmit();
	}

	return (
		<>
		<div className="modal">
			<div className="modal-header">
				<div className="modal-title">
					<h1>{title}</h1>
				</div>
				<div className="modal-options">
					<span className="btn-modal-exit" onClick={onExitClick}><FaTimes /></span>
				</div>
			</div>
			<div className="modal-body">
			<div className="modal-body-content">
				{children}
			</div>
			</div>
			<div className="modal-footer">
				<div className="modal-footer-secondary"></div>
				<div className="modal-footer-primary">
					{onSecondarySubmit && <button className="secondary" onClick={handleSecondarySubmit}>{secondarySubmitLabel}</button>}
					{onPrimarySubmit && <button className="primary" onClick={handlePrimarySubmit}>{primarySubmitLabel || 'Submit'}</button>}
				</div>
			</div>
		</div>
		<div className="modal-mask"></div>
		</>
	)
};

Modal.propTypes = {
	primarySubmitLabel: PropTypes.string,
	secondarySubmitLabel: PropTypes.string,
	onPrimarySubmit: PropTypes.func.isRequired,
	onSecondarySubmit: PropTypes.func
}

export default Modal;
